import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/useAuth';
import { makeApi } from '../api/client';
import { orgSettingsSchema, type OrgSettingsInput } from './settings.schema';

export default function SettingsRoute() {
  const { getAccessToken } = useAuth();
  const api = makeApi(getAccessToken);
  const q = useQuery({
    queryKey: ['org', 'me'],
    queryFn: async () => (await api.org.me()).data,
  });
  const { register, reset } = useForm<OrgSettingsInput>({ resolver: zodResolver(orgSettingsSchema) });
  useEffect(() => {
    if (q.data) reset({ name: q.data.org.name, address: q.data.org.address ?? '', gstin: q.data.org.gstin ?? '' });
  }, [q.data, reset]);

  return (
    <form className="max-w-lg space-y-4">
      <h1 className="text-2xl font-bold text-primary">Settings</h1>
      <p className="text-sm text-ink/60 italic">Read-only view. Edit will be available in v0.2.</p>
      <label className="block">Merchant name
        <input {...register('name')} disabled className="mt-1 w-full border rounded p-2 bg-surface text-ink/60 cursor-not-allowed" />
      </label>
      <label className="block">Address
        <input {...register('address')} disabled className="mt-1 w-full border rounded p-2 bg-surface text-ink/60 cursor-not-allowed" />
      </label>
      <label className="block">GSTIN
        <input {...register('gstin')} disabled className="mt-1 w-full border rounded p-2 bg-surface text-ink/60 cursor-not-allowed" />
      </label>
    </form>
  );
}
